export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14930.7da0fa4f.jpg";